import { memo } from 'react';
import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './Table.module.scss';

interface TableHeadCellProps {
    children: ReactNode;
    colSpan?: number;
    className?: string;
    smallPadding?: boolean;
    verticalAlign?: 'top' | 'middle' | 'bottom';
    background?: string;
    noBold?: boolean;
    noPadding?: boolean;
}

const TableHeadCell = ({
    children,
    colSpan,
    smallPadding = false,
    verticalAlign = 'top',
    background,
    className,
    noBold = false,
    noPadding = false,
    ...ariaProps
}: TableHeadCellProps) => {
    return (
        <th
            {...ariaProps}
            className={clsx(styles.tableHeadCell, className, {
                [styles.smallPadding]: smallPadding,
                [styles.noPadding]: noPadding,
                [styles.noBold]: noBold,
            })}
            colSpan={colSpan}
            style={{ verticalAlign, background }}
        >
            {children}
        </th>
    );
};

/**
 * @deprecated
 * Please use `TableHeadCell` from `@library`
 */
export default memo(TableHeadCell);
